<template>
  <sidebar-item
    v-if="hasDarkKitchen && !isAlmacenero"
    :link="{
      name: 'On Demand',
      icon: 'ni ni-shop text-primary'
    }"
  >
    <sidebar-item
      :link="{
        name: 'Estado de pedidos',
        path: '/foodcourt/pedidos/estados',
        icon: 'ni ni-cart text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Pedidos',
        path: '/foodcourt/pedidos',
        icon: 'ni ni-cart text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Tiempos de preparación',
        path: '/foodcourt/tiempos-preparacion',
        icon: 'ni ni-watch-time text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Tiempo no disponible',
        path: '/foodcourt/tiempo-no-disponible',
        icon: 'ni ni-button-power text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Disponibilidad de carta',
        path: '/foodcourt/carta-disponibilidad',
        icon: 'ni ni-collection text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Historial de carta',
        path: '/foodcourt/carta-historial',
        icon: 'ni ni-single-copy-04 text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Cargos',
        path: '/foodcourt/cargos',
        icon: 'ni ni-cart text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Niveles',
        path: '/foodcourt/niveles',
        icon: 'ni ni-diamond text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Carta',
        path: '/foodcourt/restaurant',
        icon: 'ni ni-tag text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Horario',
        path: '/foodcourt/restaurantes',
        icon: 'ni ni-cart text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Feedback',
        path: '/foodcourt/feedback',
        icon: 'ni ni-single-02 text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Plataformas',
        path: '/foodcourt/platforms',
        icon: 'ni ni-single-03 text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Reclamos',
        path: '/foodcourt/claims',
        icon: 'ni ni-book-bookmark text-primary'
      }"
    />
  </sidebar-item>
</template>

<script>
export default {
  name: 'OnDemandSection',
  computed: {
    hasDarkKitchen() {
      return this.$store.getters.getKitchenId !== null;
    },
    isAlmacenero() {
      return this.$store.getters.getUserRol === 'ALMACENERO';
    }
  }
};
</script>
